import Logo from 'assets/brand/Logo';
import {useAuth} from 'context/auth';

function DeniedLayout() {
  const {logout} = useAuth();
  return (
    <div className='min-h-screen w-full bg-canvas flex items-center justify-center px-4 py-12'>
      <div className='w-full max-w-sm'>
        <div className='flex justify-center mb-10'>
          <Logo size='lg' align='center' />
        </div>
        <div className='bg-white rounded-2xl p-6 space-y-4'>
          <p className='text-3xl font-medium tracking-tight text-slate-900 tabular-nums'>401</p>
          <h1 className='text-sm font-semibold text-slate-800'>Access denied</h1>
          <div className='flex items-center gap-2'>
            <button
              type='button'
              onClick={() => logout()}
              className='flex items-center gap-2 px-4 py-2.5 rounded-xl bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition-colors'
            >
              Logout
            </button>
            <button
              type='button'
              onClick={() => window.history.back()}
              className='px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-medium text-slate-700 hover:bg-slate-50 flex items-center gap-2 transition-colors'
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeniedLayout;
